import { ButtonProps } from 'react-bootstrap';
import { ColorScheme, StyledButton } from './Button.styles';

export interface Props extends Omit<ButtonProps, 'ref'> {
  children: React.ReactNode;
  $colorScheme?: ColorScheme;
  $noBorder?: boolean;
  bigRounded?: boolean;
  $noOutlineWhenFocus?: boolean;
  /** Icon to be displayed on the left of the button, use Glyphicon for better styling. */
  leftIcon?: React.ReactNode;
  /** Icon to be displayed on the right of the button, use Glyphicon for better styling. */
  rightIcon?: React.ReactNode;
}

const Button = ({
  children,
  bigRounded = false,
  leftIcon = null,
  rightIcon = null,
  $colorScheme,
  $noBorder = false,
  $noOutlineWhenFocus = false,
  ...rest
}: Props) => {
  return (
    // @ts-ignore
    <StyledButton
      $bigRounded={bigRounded}
      $hasIcon={!!rightIcon || !!leftIcon}
      $colorScheme={$colorScheme}
      $noBorder={$noBorder}
      $noOutlineWhenFocus={$noOutlineWhenFocus}
      {...rest}
    >
      {leftIcon && <div className="left-icon">{leftIcon}</div>}
      {children}
      {rightIcon && <div className="right-icon">{rightIcon}</div>}
    </StyledButton>
  );
};

export default Button;
